import { API, standardResponse } from "./middleware";

export async function getNotifications() {
  const url = `/api/notifications/list`;
  return API.get(url)
    .then((response) => response.data)
    .catch((error) => standardResponse(false, error.response?.data));
}
export async function getObjectByNotify(notifyReceiverId, objectId, objectType) {
  const url = `/api/notifications/getObjectByNotify?notifyReceiverId=${notifyReceiverId}&objectId=${objectId}&objectType=${objectType}`;
  return API.get(url)
    .then((response) => response.data)
    .catch((error) => standardResponse(false, error.response?.data));
}
export async function countNotifications() {
  const url = `/api/notifications/count`;
  return API.get(url)
    .then((response) => response.data)
    .catch((error) => standardResponse(false, error.response?.data));
}
export async function markAllAsRead() {
  const url = "/api/notifications/markAllAsRead";

  return API.post(url)
    .then((response) => response.data)
    .catch((error) => standardResponse(false, error.response?.data));
}
